import { render, staticRenderFns } from "./ChpSettings.vue?vue&type=template&id=0e979152&"
import script from "./ChpSettings.vue?vue&type=script&lang=ts&"
export * from "./ChpSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports